/** Private browsing and embedded webviews can make storage unavailable. */
export function storage(): Storage | null {
  try {
    return globalThis.localStorage ?? null;
  } catch {
    return null;
  }
}
